export class AbstractList {
  type = ``;
  items: NodeListOf<HTMLElement>;
  item: HTMLElement;

  constructor(item: HTMLElement) {
    this.item = item;
    this.type = this.item.dataset.tasksListType!;
    this.items = this.item.querySelectorAll(`.js-task-item`);
  }

  getItems() {
    return this.items;
  }

  addElement(element: HTMLElement) {
    this.item.appendChild(element);
  }

  updateItems() {
    this.items = this.item.querySelectorAll(`.js-task-item`);
  }
}
